import { render, staticRenderFns } from "./HumanCapitalWorkingAverageReport.vue?vue&type=template&id=3d98b856&scoped=true&"
import script from "./HumanCapitalWorkingAverageReport.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalWorkingAverageReport.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalWorkingAverageReport.vue?vue&type=style&index=0&id=3d98b856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d98b856",
  null
  
)

export default component.exports